<div class="mr-note" [attr.data-variant]="block.variant || null">
  <div class="mr-note-text" [innerHTML]="t(block.text) | markdownHtml"></div>
</div>
